import { render, staticRenderFns } from "./rightPage.vue?vue&type=template&id=ffecea3e&scoped=true&"
import script from "./rightPage.vue?vue&type=script&lang=js&"
export * from "./rightPage.vue?vue&type=script&lang=js&"
import style0 from "./rightPage.vue?vue&type=style&index=0&id=ffecea3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffecea3e",
  null
  
)

export default component.exports